export const enum SignStatus {
  Unknown = 0,
  NeedPositions = 1,
  ReadyToSign = 2,
  WaitingForOthers = 3,
  Completed = 4,
}
